<template>
  <div class="time-content">
    <span class="title">Время:</span>
    <div
      :class="[
        'time',
        {
          error: errorTime,
        },
      ]"
      style="margin-bottom: 9px"
    >
      <input
        type="number"
        v-model="inputHour"
        @input="handleHourInput"
        class="input__field"
        min="0"
        max="23"
      />
      :
      <input
        type="number"
        v-model="inputMinutes"
        @input="handleMinutesInput"
        class="input__field"
        min="0"
        max="59"
      />
    </div>

    <div class="time">
      <div class="time__block">
        <span class="time__scroll">
          <span class="time__block-title">ЧЧ</span>
          <div
            class="time__block-item"
            v-for="(i, hour) in 24"
            :key="hour + 'hour'"
            @click="inputHour = hour < 10 ? '0' + hour : hour"
          >
            {{ 10 > hour ? "0" + hour : hour }}
          </div>
        </span>
      </div>
      <div class="time__block">
        <span class="time__scroll">
          <span class="time__block-title">ММ</span>
          <div
            class="time__block-item"
            v-for="(i, minut) in 60"
            :key="minut + 'min'"
            @click="inputMinutes = minut < 10 ? '0' + minut : minut"
          >
            {{ 10 > minut ? "0" + minut : minut }}
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import masker from "@titou10/v-mask/dist/masker";

export default {
  name: "Time",
  components: {},
  data() {
    return {
      inputHour: "00",
      inputMinutes: "00",
    };
  },
  computed: {
    errorTime() {
      return (
        !this.inputHour ||
        !this.inputMinutes ||
        this.inputHour < 0 ||
        this.inputHour > 23 ||
        this.inputMinutes > 59 ||
        this.inputMinutes < 0
      );
    },
  },
  methods: {
    handleHourInput({ target }) {
      if (+target.value && target.value.length === 1) {
        target.value = "0" + target.value;
      }

      if (target.value.length === 3) {
        target.value = target.value.substring(1);
      }

      this.inputHour = masker(target.value, "##");
    },
    handleMinutesInput({ target }) {
      if (+target.value && target.value.length === 1) {
        target.value = "0" + target.value;
      }

      if (target.value.length === 3) {
        target.value = target.value.substring(1);
      }

      this.inputMinutes = masker(target.value, "##");
    },
    setValue() {
      this.$emit("setValue", `${this.inputHour}:${this.inputMinutes}`);
    },
  },
  watch: {
    inputHour() {
      this.setValue();
    },
    inputMinutes() {
      this.setValue();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: $dark-gray;
  margin-bottom: 12px;
}

input {
  height: 40px;
  width: 90px;
  text-align: center;
  font-weight: bold;
}

.time-content {
  position: absolute;
  background: white;
  z-index: 2;
  top: 48px;
  padding: 30px;
  border: 1px solid rgba(0, 65, 102, 0.2);
  border-radius: 4px;
}

.time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.time__block {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 90px;
  height: 164px;
  padding: 9px 7px 9px 0;
  border: 1px solid #b8cad5;
  border-radius: 4px;

  .time__block-title {
    color: $dark-gray;
  }

  .time__scroll {
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 66, 105, 0.06);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 66, 105, 0.24);
      border-radius: 4px;
    }
  }

  .time__block-item {
    cursor: pointer;
    margin: 3px 0;
    transition: 0.2s;

    &:hover {
      color: $blue;
    }
  }
}
</style>
